export default __webpack_public_path__ + "static/media/profile-icon.870d70ca.svg";